const typography = {
  defaultFontSize: 16,
  defaultTextRendering: '"optimizeLegibility"',
  fontPrimary: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
  fontSecondary:
    '"Raleway", "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
  fontSizeHeading: '2rem',
  fontSizeLink: '1.25rem',
  fontSizeP: '1rem',
  fontSizeSubHeading: '1.25rem',
  fontWeightBold: 700,
  fontWeightRegular: 400,
  fontWeightSemiBold: 600,
  letterSpacingLarge: '0.0313rem',
  letterSpacingMedium: '0.03rem',
  letterSpacingSmall: '0.025rem',
  letterSpacingXLarge: '0.04rem',
  letterSpacingXSmall: '0.02rem',
  lineHeightDefault: 1.6,
  lineHeightHeading: 1.2,
  lineHeightSubHeading: 1.43,
  lineHeightTopic: 1.5,
}

export default typography
